import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';
import { Datepicker } from 'vanillajs-datepicker';
import { parseDate } from 'utils/date-utils';

class DateInput extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }

    handleChange(e) {
        this.props.setFieldValue(this.props.name, e.target.value);
    }

    componentDidMount() {
        const options = {
            buttonClass: "btn",
            format: "yyyy-mm-dd",
            language: "pl",
            daysOfWeekHighlighted: [0, 6]
        }

        // TODO import locales from vanillajs-datepicker/dist/js/locales/pl.js
        const locales = {
            pl: {
                days: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
                daysShort: ["Niedz.", "Pon.", "Wt.", "Śr.", "Czw.", "Piąt.", "Sob."],
                daysMin: ["Ndz.", "Pn.", "Wt.", "Śr.", "Czw.", "Pt.", "Sob."],
                months: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
                monthsShort: ["Sty.", "Lut.", "Mar.", "Kwi.", "Maj", "Cze.", "Lip.", "Sie.", "Wrz.", "Paź.", "Lis.", "Gru."],
                today: "Dzisiaj",
                weekStart: 1,
                clear: "Wyczyść",
                format: "yyyy-mm-dd"
            }
        }

        Object.assign(Datepicker.locales, locales);
        new Datepicker(this.myRef.current, options);
        this.handleChange = this.handleChange.bind(this);
        this.myRef.current.addEventListener("changeDate", this.handleChange);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && parseDate(this.props.value) != null) {
            this.myRef.current.datepicker.setDate(this.props.value);
        }
    }

    componentWillUnmount() {
        this.myRef.current.removeEventListener('changeDate', this.handleChange);
        this.myRef.current.datepicker.destroy();
    }

    render() {
        const { setFieldValue, ...rest } = this.props;
        let mask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
        return (
            <MaskedInput mask={mask} type="text" {...rest} render={(textMaskRef, props) => (
                <input
                  {...props}
                  ref={node => {
                    textMaskRef(node); // reference for the MaskedInput component
                    this.myRef.current = node; // reference for this component
                  }}
                />
              )}/>
        )
    }
}

export default DateInput;
